import React, {useEffect, useState} from 'react';
import axios from '../../services/axiosInstance';
import MsgSelectModal from "../../components/web/modal/MsgSelectModal";
import AdminPageEvent from "../../components/web/layoutsadmin/AdminPageEvent";
import MsgConfirmModal from "../../components/web/modal/MsgConfirmModal";
import {MdKeyboardArrowDown} from "react-icons/md";
import maCateImg from "../../assets/img/m-a-cate.png";
import AdminSpBoosterPopup from "../../components/web/modal/AdminSpBoosterPopup";
import AdminSearchEvent from "../../components/web/layoutsadmin/AdminSearchEvent";

function AdminSpBoosterPg() {

    const [data, setData] = useState([]);
    const LCAT = localStorage.getItem('adminToken');
    const [checked, setChecked] = useState([]);

    const checkBoxChange = (dataItem) => {
        setChecked((prevSelectedData) => {
            if (prevSelectedData.some(item => item.seqNum === dataItem.seqNum)) {
                return prevSelectedData.filter((item) => item.seqNum !== dataItem.seqNum);
            } else {
                return [...prevSelectedData, dataItem];
            }
        });
    };

    const allCheckBoxChange = (e) => {
        if (e.target.checked) {
            setChecked(data);
        } else {
            setChecked([]);
        }
    };

    useEffect(() => {
        selectedBoosterList();
    }, [])

    const selectedBoosterList = () => {
        axios({
            method: 'get',
            url: '/shopping/booster/selectedBoosterList',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setData(response.data);
                setChecked([]);
            })
            .catch((error) => {

            });
    };

    const [noSelectedSpBoosterShow, setNoSelectedSpBoosterShow] = useState(false);
    const noSelectedSpBoosterMsg = "수정할 항목을 선택해주세요"
    const closeNoSelectedSpBoosterShow = (() => {
        setNoSelectedSpBoosterShow(false);
    })

    const [spBoosterModifyShow, setSpBoosterModifyShow] = useState(false);
    const closeSpBoosterModifyShow = (() => {
        setSpBoosterModifyShow(false);
    })
    const openSpBoosterModifyShow = (() => {
        if (!checked || checked.length === 0) {
            setNoSelectedSpBoosterShow(true);
        } else {
            setSpBoosterModifyShow(true);
        }
    })

    const [spBoosterAddShow, setSpBoosterAddShow] = useState(false);
    const closeSpBoosterAddShow = (() => {
        setSpBoosterAddShow(false);
    })

    const saveSpBooster = (fields) => {
        axios({
            method: 'post',
            url: '/shopping/booster/saveSpBooster',
            data: {
                shopNm: fields.shopNm,
                name: fields.name,
                optionParent: fields.optionParent,
                option: fields.option,
                quantity: fields.quantity,
                price: fields.price,
                totalPrice: fields.totalPrice,
                url: fields.url,
                image: fields.image,
                shopUrl: fields.shopUrl,
            },
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setData([...data, response.data]);
                closeSpBoosterAddShow();
            })
            .catch((error) => {
                console.log("등록실패 : ", error)
            });
    }

    const modifySpBooster = ((modifyData) => {
        console.log("modifyData : ", modifyData)
        axios({
            method: 'post',
            url: '/shopping/booster/modifySpBooster',
            data: modifyData,
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                const updatedItem = response.data; // 수정된 항목
                const updatedData = data.map(item =>
                    item.seqNum === updatedItem.seqNum ? updatedItem : item
                );
                setChecked([]);
                setData(updatedData); // 🔁 상태 업데이트
                closeSpBoosterModifyShow(false);
            })
            .catch((error) => {
                console.log("수정실패 : ", error)
            });
    });

    const [spBoosterDeleteShow, setSpBoosterDeleteShow] = useState(false);
    const spBoosterDeleteMsg1 = "선택하신 쇼핑몰 정보를 삭제하시겠습니까?"
    const spBoosterDeleteMsg2 = "삭제 후 복구가 불가합니다"
    const closeSpBoosterDeleteShow = (() => {
        setSpBoosterDeleteShow(false);
    })

    const deleteSpBooster = ((modifyData) => {
        axios({
            method: 'post',
            url: '/shopping/booster/deleteSpBooster',
            data: modifyData,
        })
            .then((response) => {
                const updatedData = data.filter((item) => !modifyData.some((deletedItem) => deletedItem.seqNum === item.seqNum));
                setData(updatedData);
                setChecked([]);
                closeSpBoosterDeleteShow();
            })
            .catch((error) => {
                console.log("삭제실패 : ", error)
            });
    });

    const [searchInput, setSearchInput] = useState("");
    const handleSearchInput = (e) => {
        setSearchInput(e.target.value);
    }

    const [displayLimit, setDisplayLimit] = useState(50);
    const filteredData = data.filter(item =>
        item.shopNm?.toLowerCase().includes(searchInput.toLowerCase()) ||
        item.shopUrl?.toLowerCase().includes(searchInput.toLowerCase()) ||
        item.url?.toLowerCase().includes(searchInput.toLowerCase())
    );

    const loadMoreData = () => {
        setDisplayLimit(prev => prev + 50);
    };

    const displayedData = filteredData.slice(0, displayLimit);

    const toExternalUrl = (url) => {
        if (!url) return '#';
        const s = String(url).trim();

        if (/^javascript:/i.test(s)) return '#'; // 보안
        if (/^https?:\/\//i.test(s) || /^\/\//.test(s)) return s; // 이미 프로토콜 있음

        return `https://${s}`; // 없으면 https 붙여줌
    };

    /** endregion */

    return (
        <div className="AdminPaypalExPg">
            <div className="admin-work-title">
                <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                <p className="p-t-6">쇼핑부스터 목록</p>
            </div>
            <div className="admin-wrap">
                <div className="admin-wrap-card">
                    <div className="admin-event-wrap">
                        <div className="admin-event-wrap-btn">
                            <AdminSearchEvent searchInput={searchInput} handleSearchInputChange={handleSearchInput} />
                        </div>
                        <div className="admin-event-wrap-btn gap10">
                            <button onClick={() => setSpBoosterDeleteShow(true)}
                                    className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event">삭제
                            </button>
                            <button onClick={openSpBoosterModifyShow}
                                    className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event">수정
                            </button>
                            <button onClick={() => setSpBoosterAddShow(true)}
                                    className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event">신규등록
                            </button>
                        </div>
                    </div>
                    <div className="div-tb">
                        <div className="div-tb-head ht-60">
                            <div style={{width: "40px"}}><input className="admin-input-chkBox m-0-a" type="checkbox"
                                                                checked={checked.length === data.length}
                                                                onChange={allCheckBoxChange}/></div>
                            <div style={{width: "100px"}}><p>쇼핑몰</p></div>
                            <div style={{width: "120px"}}><p>상품명</p></div>
                            <div style={{width: "120px"}}><p>옵션프레임</p></div>
                            <div style={{width: "120px"}}><p>옵션</p></div>
                            <div style={{width: "120px"}}><p>수량</p></div>
                            <div style={{width: "120px"}}><p>가격</p></div>
                            <div style={{width: "120px"}}><p>최종가격</p></div>
                            <div style={{width: "120px"}}><p>URL</p></div>
                        </div>
                        {displayedData.map((cData, i) => (
                            <div key={cData.seqNum} className="div-tb-body ht-70">
                                <div style={{width: "40px"}}>
                                    <input className="admin-input-chkBox m-0-a" type="checkbox" name={cData.seqNum}
                                           checked={checked.some(item => item.seqNum === cData.seqNum)}
                                           onChange={() => checkBoxChange(cData)}/>
                                </div>
                                <div style={{width: "100px"}} className="c-point"
                                     onClick={() => window.open(toExternalUrl(cData.shopUrl), "_blank", "noopener,noreferrer")}>
                                    <p style={{cursor: "pointer"}}>{cData.shopNm}</p>
                                </div>
                                <div style={{width: "120px"}}><p>{cData.name}</p></div>
                                <div style={{width: "120px"}}><p>{cData.optionParent}</p></div>
                                <div style={{width: "120px"}}><p>{cData.option}</p></div>
                                <div style={{width: "120px"}}><p>{cData.quantity}</p></div>
                                <div style={{width: "120px"}}><p>{cData.price}</p></div>
                                <div style={{width: "120px"}}><p>{cData.totalPrice}</p></div>
                                <div style={{width: "120px"}}><p>{cData.url}</p></div>
                            </div>
                        ))}
                    </div>

                    {/*더보기버튼*/}
                    {filteredData.length > displayLimit && (
                        <div className="text-center m-t-20">
                            <button className="admin-btn-long admin-btn-basic p-l-10" onClick={loadMoreData}>더보기
                                <MdKeyboardArrowDown className="m-l3 font-s-17"/>
                            </button>
                        </div>
                        )}
                    
                </div>
            </div>
            {noSelectedSpBoosterShow ?
                <MsgConfirmModal noSelectedSpBoosterShow={noSelectedSpBoosterShow}
                                 noSelectedSpBoosterMsg={noSelectedSpBoosterMsg}
                                 closeNoSelectedSpBoosterShow={closeNoSelectedSpBoosterShow}/>
                :
                spBoosterAddShow ?
                    <AdminSpBoosterPopup spBoosterAddShow={spBoosterAddShow} closeSpBoosterAddShow={closeSpBoosterAddShow}
                                         saveSpBooster={saveSpBooster}/>
                    :
                    spBoosterModifyShow ?
                        <AdminSpBoosterPopup spBoosterModifyShow={spBoosterModifyShow}
                                             closeSpBoosterModifyShow={closeSpBoosterModifyShow}
                                             spBoosterModifychecked={checked} modifySpBooster={modifySpBooster}/>
                        :
                        spBoosterDeleteShow ?
                            <MsgSelectModal spBoosterDeleteShow={spBoosterDeleteShow}
                                            closeSpBoosterDeleteShow={closeSpBoosterDeleteShow}
                                            spBoosterDeleteChecked={checked}
                                            spBoosterDeleteMsg1={spBoosterDeleteMsg1}
                                            spBoosterDeleteMsg2={spBoosterDeleteMsg2}
                                            deleteSpBooster={deleteSpBooster}/>
                            :
                            null
            }
        </div>
    );
}

export default AdminSpBoosterPg
